import { render } from "./ConfirmEmail.vue?vue&type=template&id=fb7f1942"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js"
script.render = render

export default script